import { cx } from "./classNames";

type NoticeTone = "success" | "info";

const toneClassMap: Record<NoticeTone, string> = {
  success: "bg-brand-highlight/20 border-brand-accent/20 text-brand-accent",
  info: "bg-red-50 border-red-100 text-red-600",
};

export interface StatusNoticeProps {
  tone: NoticeTone;
  message: string;
  className?: string;
}

export function StatusNotice({ tone, message, className }: StatusNoticeProps) {
  return (
    <div
      className={cx(
        "motion-fade-up rounded-xl border p-4 text-sm font-medium",
        toneClassMap[tone],
        className,
      )}
      role="status"
      aria-live="polite"
    >
      {message}
    </div>
  );
}
